module.exports = __webpack_public_path__ + "img/index-section6-friend5.a3e0ddcf.svg";